import { Component, forwardRef, Input, ChangeDetectionStrategy } from "@angular/core";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { TextBaseComponent } from "../text-base.component";
import { GetFocusDirective } from "../../../directives/get-focus.directive";


export interface TextAreaStyles {
	width?: number,
	height?: number,
	maxLength?: number
}
@Component({
    selector: "rl-text-area",
    templateUrl: "./text-area.component.html",
    styleUrls: ["./text-area.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextAreaComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, FormsModule, GetFocusDirective]
})
export class TextAreaComponent extends TextBaseComponent {

	@Input()
	disabled: boolean = false;

	@Input()
	id: string = null;

	@Input()
	placeholder: string = "";

	@Input()
	showCounter = false;

	@Input()
	contentLength: number = 0;

	@Input()
	focused$: BehaviorSubject<boolean>;

	@Input()
	dataLabel: string = "textAreaInput";

	@Input()
	styles: TextAreaStyles = {};

	constructor() {
		super();
	}

	keyUp($event: KeyboardEvent) {
		const target: HTMLInputElement = $event.target as HTMLInputElement;
		const value = target.value;
		this.onTouched();
		this.change(value);
	}

	blur() {
		this.onTouched();
	}

	change(value: string) {
		this.contentLength = value?.length || 0;
	}
}
